var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 2.66667V0L12 4.66667L7.33333 9.33333V6.6C4 6.6 1.66667 7.66667 0 10C0.666667 6.66667 2.66667 3.33333 7.33333 2.66667Z",
    fill: "#6A7AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBlue);
export default __webpack_public_path__ + "static/media/export-blue.054dce8f9c37c67b2ce87bb63a672212.svg";
export { ForwardRef as ReactComponent };